import React from 'react';

export function TypingIndicator() {
  return (
    <div className="typing-indicator mt-2" aria-label="AI is typing">
      <span />
      <span />
      <span />
    </div>
  );
}